import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Pages from './pages';
import Dashboard from '../../container/dashboard';
import withAdminLayout from '../../layout/withAdminLayout';

// import DashboardTW from '../../container/modules/company/dashboard/Dashboard';

const NotFound = lazy(() => import('../../container/pages/404'));

const Employee = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
          <Spin />
        </div>
      }
    >
      <Routes>
        {/* <Route index path="/*" element={<Dashboard />} /> */}
        {/* <Route index path="/*" element={<DashboardTW />} /> */}
        {/* <Route path="pages/*" element={<Pages />} /> */}
        <Route index element={<Dashboard />} />
        <Route path="/*" element={<Pages />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Employee);
